export class UnnumberedSeat {
  constructor(params) {
    this.params = params;
    this.template = "<div/>";
    return this.render();
  }

  render() {
    if (this.params.standSeat) {
      this.el = $(this.template);

      this.el.css({
        top: `${(this.params.y * this.params.height) - this.params.height}px`,
        left: `${(this.params.x * this.params.width) - this.params.width}px`,
      });

      this.el.appendTo(this.params.container);

      const className = this.params.standSeat.type === "default" ? "stand-seat" : "unnumbered-seating-seat";

      this.el.attr({
        class: className,
        "data-status": this.params.standSeat.status,
        "data-type": this.params.standSeat.type,
        "data-selected": false,
      }).data({
        coll: this.params.coll,
        row: this.params.row,
        area_uuid: this.params.standSeat.area_uuid,
      });

      this.params.standSeat.el = this.el;
    }

    return this;
  }
}

export default function unnumberedSeatsFactory(fragment, standSeat, width, height) {
  return new UnnumberedSeat({
    standSeat,
    x: standSeat.x,
    y: standSeat.y,
    row: standSeat.row,
    coll: standSeat.seat,
    width,
    height,
    container: fragment,
  });
}
window.StandSeatsFactory = unnumberedSeatsFactory;
